import { publicComponentOption } from "dependencies/base"
import { toSelectOpt } from "utils"
const optDes = {
  ...publicComponentOption,
  "chartOption.regionName": "选中区域名称",
  refreshTime: "间隔刷新时间",
  updateTimer: "数据源轮询时间",
  restDataUrl: "外接数据源地址",
  name: "当前地图",
  deepMap: "开启下钻",
  zoom: "地图缩放",
  center: "地图中心点经纬度",
  areaColor: "地图区块颜色",
  primaryBorderColor: "地图边框颜色",
  primaryBorderWidth: "地图边界默认border宽度",
  selectBorderColor: "地图边框颜色",
  selectColor: "地图选中和hover的颜色",
  selectBorderWidth: "地图边界选中border宽度",
  showLabel: "显示地图标签",
  showScatter: "显示散点图",
  showHot: "显示热力图",
  showLines: "显示飞线图",
  "label.labelFontColor:": "地图标签字体颜色",
  "label.labelFontFamily": "地图标签字体样式",
  "label.labelFontSize": "地图标签字体大小",
  "label.labelFontWeight": "地图标签字体粗细",
  "select.selectFontColor:": "选中标签字体颜色",
  "select.selectFontFamily": "选中标签字体样式",
  "select.selectFontSize": "选中标签字体大小",
  "select.selectFontWeight": "选中标签字体粗细",
  "chartOption.scatter.selectName": "散点名称",
  "scatter.rippleEffect.color.colorStops": "散点波纹渐变",
  "scatter.rippleEffect.number": "散点大小",
  "scatter.rippleEffect.scale": "散点波纹缩放比",
  "scatter.rippleEffect.brushType": "散点波纹图标",
  "scatter.rippleEffect.period": "散点波纹动画",
  "scatter.label.show": "飞线标签字体显示",
  "scatter.label.labelFontColor": "飞线标签字体颜色",
  "scatter.label.labelFontFamily": "飞线标签字体样式",
  "scatter.label.labelFontSize": "飞线标签字体大小",
  "scatter.label.labelFontWeight": "飞线标签字体粗细",
  "scatter.label.offset": "飞线标签字体",
  "lines.data": "飞线数据",
  "lines.centerData": "飞线中心点数据",
  "lines.lineStyle.color": "飞线颜色",
  "lines.lineStyle.width": "飞线粗细",
  "lines.lineStyle.type": "飞线样式",
  "lines.lineStyle.curveness": "飞线曲度",
  "lines.effect.show": "飞线图标显示",
  "lines.effect.symbolSize": "飞线图标大小",
  "lines.effect.period": "飞线图标速度",
  "lines.effect.symbol": "飞线图标",
  "lines.effect.trailLength": "飞线图标尾迹长度",
  "lines.label.show": "飞线标签显示",
  "lines.label.position": "飞线标签位置",
  "lines.label.fontColor": "飞线标签字体颜色",
  "lines.label.fontFamily": "飞线标签字体样式",
  "lines.label.fontSize": "飞线标签字体大小",
  "lines.label.fontWeight": "飞线标签字体粗细"
}
export const getOptDes = toSelectOpt.bind(this, optDes)
